import { render, staticRenderFns } from "./ReleaseDetail.vue?vue&type=template&id=3c7a5009&scoped=true"
import script from "./ReleaseDetail.vue?vue&type=script&lang=js"
export * from "./ReleaseDetail.vue?vue&type=script&lang=js"
import style0 from "./ReleaseDetail.vue?vue&type=style&index=0&id=3c7a5009&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a5009",
  null
  
)

export default component.exports